import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, unref as _unref, vModelText as _vModelText, withDirectives as _withDirectives, vModelSelect as _vModelSelect, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "orchit-dashboard-container orchit-animate-fade-up" }
const _hoisted_2 = { class: "row mb-4" }
const _hoisted_3 = { class: "col-12" }
const _hoisted_4 = { class: "orchit-card p-2 d-inline-flex bg-white rounded-pill shadow-sm border" }
const _hoisted_5 = {
  class: "nav nav-pills custom-orchit-pills",
  id: "dashboardTabs",
  role: "tablist"
}
const _hoisted_6 = {
  class: "nav-item",
  role: "presentation"
}
const _hoisted_7 = {
  class: "nav-item",
  role: "presentation"
}
const _hoisted_8 = {
  class: "tab-content",
  id: "dashboardTabsContent"
}
const _hoisted_9 = {
  key: 0,
  class: "tab-pane fade show active"
}
const _hoisted_10 = { class: "row g-4 mb-5 justify-content-center" }
const _hoisted_11 = { class: "orchit-card p-4 h-100 stat-card" }
const _hoisted_12 = { class: "mt-3" }
const _hoisted_13 = { class: "stat-value text-truncate" }
const _hoisted_14 = { class: "stat-label text-truncate" }
const _hoisted_15 = { class: "row mb-5" }
const _hoisted_16 = { class: "col-12" }
const _hoisted_17 = { class: "orchit-card p-4 overflow-hidden" }
const _hoisted_18 = { class: "details-header mb-4 d-flex justify-content-between align-items-center" }
const _hoisted_19 = {
  class: "chart-badge stat-icon-wrap",
  style: {"background-color":"var(--orchit-primary-light)","color":"var(--orchit-primary)"}
}
const _hoisted_20 = { class: "chart-container" }
const _hoisted_21 = { class: "row g-4 mb-4" }
const _hoisted_22 = { class: "col-md-6" }
const _hoisted_23 = { class: "orchit-card p-4 h-100" }
const _hoisted_24 = { class: "d-flex gap-4" }
const _hoisted_25 = {
  class: "user-breakdown-item p-3 rounded-3 flex-fill",
  style: {"background":"rgba(16, 185, 129, 0.1)","border":"1px solid rgba(16, 185, 129, 0.2)"}
}
const _hoisted_26 = {
  class: "breakdown-value",
  style: {"font-size":"1.5rem","font-weight":"800","color":"var(--orchit-text-primary)"}
}
const _hoisted_27 = {
  class: "user-breakdown-item p-3 rounded-3 flex-fill",
  style: {"background":"rgba(245, 158, 11, 0.1)","border":"1px solid rgba(245, 158, 11, 0.2)"}
}
const _hoisted_28 = {
  class: "breakdown-value",
  style: {"font-size":"1.5rem","font-weight":"800","color":"var(--orchit-text-primary)"}
}
const _hoisted_29 = {
  key: 1,
  class: "tab-pane fade show active"
}
const _hoisted_30 = { class: "orchit-card p-4 mb-4" }
const _hoisted_31 = { class: "d-flex flex-wrap gap-2 mb-4" }
const _hoisted_32 = ["onClick"]
const _hoisted_33 = { class: "row g-3 align-items-end border-top pt-4" }
const _hoisted_34 = { class: "col-md-3" }
const _hoisted_35 = { class: "col-md-3" }
const _hoisted_36 = { class: "col-md-3" }
const _hoisted_37 = { class: "col-md-3" }
const _hoisted_38 = ["disabled"]
const _hoisted_39 = {
  key: 1,
  class: "spinner-border spinner-border-sm me-2"
}
const _hoisted_40 = { class: "row g-4 mb-4" }
const _hoisted_41 = { class: "col-md-3" }
const _hoisted_42 = { class: "orchit-card p-4 h-100 stat-card" }
const _hoisted_43 = {
  class: "stat-icon-wrap",
  style: {"background-color":"rgba(124, 58, 237, 0.1)","color":"#7C3AED"}
}
const _hoisted_44 = { class: "mt-3" }
const _hoisted_45 = { class: "stat-value" }
const _hoisted_46 = { class: "col-md-3" }
const _hoisted_47 = { class: "orchit-card p-4 h-100 stat-card" }
const _hoisted_48 = {
  class: "stat-icon-wrap",
  style: {"background-color":"rgba(6, 182, 212, 0.1)","color":"#06B6D4"}
}
const _hoisted_49 = { class: "mt-3" }
const _hoisted_50 = { class: "stat-value" }
const _hoisted_51 = { class: "col-md-3" }
const _hoisted_52 = { class: "orchit-card p-4 h-100 stat-card" }
const _hoisted_53 = {
  class: "stat-icon-wrap",
  style: {"background-color":"rgba(16, 185, 129, 0.1)","color":"#10B981"}
}
const _hoisted_54 = { class: "mt-3" }
const _hoisted_55 = { class: "stat-value" }
const _hoisted_56 = { class: "col-md-3" }
const _hoisted_57 = { class: "orchit-card p-4 h-100 stat-card" }
const _hoisted_58 = {
  class: "stat-icon-wrap",
  style: {"background-color":"rgba(245, 158, 11, 0.1)","color":"#F59E0B"}
}
const _hoisted_59 = { class: "mt-3" }
const _hoisted_60 = { class: "stat-value" }
const _hoisted_61 = { class: "orchit-card overflow-hidden" }
const _hoisted_62 = { class: "table-responsive" }
const _hoisted_63 = { class: "table orchit-table mb-0" }
const _hoisted_64 = { class: "d-flex align-items-center" }
const _hoisted_65 = {
  class: "stat-icon-wrap me-2",
  style: {"width":"32px","height":"32px","font-size":"12px","background":"rgba(124, 58, 237, 0.05)","color":"#7C3AED"}
}
const _hoisted_66 = { class: "fw-bold" }
const _hoisted_67 = { class: "small text-muted" }
const _hoisted_68 = { class: "fw-bold" }
const _hoisted_69 = {
  class: "badge rounded-pill px-3 py-2",
  style: {"background":"rgba(124, 58, 237, 0.1)","color":"#7C3AED","font-weight":"700","font-size":"0.85rem"}
}
const _hoisted_70 = { key: 2 }
const _hoisted_71 = {
  colspan: "4",
  class: "text-center py-5"
}
const _hoisted_72 = { class: "opacity-50 mb-3" }

import { ref, onMounted, computed, reactive } from 'vue';
import apiService from '@/services/apiService';
import apexchart from "vue3-apexcharts";

// --- Tab Management ---

export default /*@__PURE__*/_defineComponent({
  __name: 'Dashboard',
  setup(__props) {

const activeTab = ref('main');

// --- Main Overview State ---
const rawCounts = ref<any>({});
const isLoading = ref(true);

const stats = ref([
  { label: 'Workspaces', value: '0', icon: 'grid', color: '#7C3AED', route: '/all-workspaces', key: 'workspaces' },
  { label: 'Total Users', value: '0', icon: 'users', color: '#06B6D4', route: '/registered-users', key: 'users_total' },
  { label: 'AI Agents', value: '0', icon: 'target', color: '#10B981', route: '/admin/agents', key: 'agents' },
  { label: 'Total Prompts', value: '0', icon: 'command', color: '#F59E0B', route: '/prompts', key: 'prompts' },
  { label: 'Active Packages', value: '0', icon: 'package', color: '#6366F1', route: '/packages', key: 'packages' },
  { label: 'Blogs', value: '0', icon: 'book-open', color: '#D946EF', route: '/blogs', key: 'blogs' },
  { label: 'Industries', value: '0', icon: 'layers', color: '#EC4899', route: '/industries', key: 'industries' },
  { label: 'Industry Users', value: '0', icon: 'user-plus', color: '#F43F5E', route: '/industry-users', key: 'industryUsers' },
  { label: 'Knowledge Bases', value: '0', icon: 'database', color: '#F59E0B', route: '/admin/knowledge-bases', key: 'knowledgeBases' },
  { label: 'Technologies', value: '0', icon: 'cpu', color: '#10B981', route: '/technologies', key: 'technologies' },
  { label: 'Tools', value: '0', icon: 'tool', color: '#3B82F6', route: '/tools', key: 'tools' },
  { label: 'Platforms', value: '0', icon: 'monitor', color: '#64748B', route: '/platforms', key: 'platforms' },
  { label: 'Card Types', value: '0', icon: 'file-text', color: '#8B5CF6', route: '/cardtypes', key: 'cardTypes' },
  { label: 'Card Statuses', value: '0', icon: 'check-circle', color: '#14B8A6', route: '/card-statuses', key: 'cardStatuses' },
  { label: 'Card Priorities', value: '0', icon: 'flag', color: '#EF4444', route: '/cardpriorities', key: 'cardPriorities' },
  { label: 'Job Titles', value: '0', icon: 'briefcase', color: '#EAB308', route: '/job-titles', key: 'jobTitles' },
  { label: 'Company Roles', value: '0', icon: 'users', color: '#84CC16', route: '/cms-roles-permissions', key: 'companyRoles' },
  { label: 'Team Roles', value: '0', icon: 'users', color: '#0EA5E9', route: '/team-roles', key: 'teamRoles' },
]);

// --- Token Usage State ---
const isTokensLoading = ref(false);
const tokenUsageData = ref<any[]>([]);
const tokenUsageTotals = ref<any>({ total_tokens: 0, input_tokens: 0, output_tokens: 0 });
const tokenFilters = reactive({
  startDate: '',
  endDate: '',
  userType: ''
});

// --- Quick Filters Logic ---
const activePreset = ref('');
const datePresets = [
  { id: 'today', label: 'Today' },
  { id: 'yesterday', label: 'Yesterday' },
  { id: 'this_week', label: 'This Week' },
  { id: 'last_week', label: 'Last Week' },
  { id: 'this_month', label: 'This Month' },
  { id: 'last_month', label: 'Last Month' },
];

const applyDatePreset = (presetId: string) => {
  activePreset.value = presetId;
  const now = new Date();
  let start = new Date();
  let end = new Date();

  // Helper to format date to YYYY-MM-DD
  const formatDate = (date: Date) => {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
  };

  switch (presetId) {
    case 'today':
      // Both start and end are today
      break;
    case 'yesterday':
      start.setDate(now.getDate() - 1);
      end.setDate(now.getDate() - 1);
      break;
    case 'this_week':
      // Get current day (0 is Sunday, 1 is Monday...)
      const currentDayOfWeek = now.getDay();
      // Calculate diff to Monday (if Sunday, go back 6 days, otherwise go back currentDay-1)
      const diffToMonday = currentDayOfWeek === 0 ? 6 : currentDayOfWeek - 1;
      start.setDate(now.getDate() - diffToMonday);
      break;
    case 'last_week':
      const mondayOfThisWeek = new Date();
      const currentDayIdx = now.getDay();
      const diffToMon = currentDayIdx === 0 ? 6 : currentDayIdx - 1;
      mondayOfThisWeek.setDate(now.getDate() - diffToMon);
      
      start.setDate(mondayOfThisWeek.getDate() - 7);
      end.setDate(mondayOfThisWeek.getDate() - 1);
      break;
    case 'this_month':
      start = new Date(now.getFullYear(), now.getMonth(), 1);
      break;
    case 'last_month':
      start = new Date(now.getFullYear(), now.getMonth() - 1, 1);
      end = new Date(now.getFullYear(), now.getMonth(), 0);
      break;
  }

  tokenFilters.startDate = formatDate(start);
  tokenFilters.endDate = formatDate(end);
  
  fetchTokenUsage();
};

// --- Helper Functions ---
const formatNumber = (num: number) => {
  return new Intl.NumberFormat().format(num);
};

// --- API Methods ---
const fetchDashboardData = async () => {
  try {
    isLoading.value = true;
    const response = await apiService.getDashboardCounts();
    if (response) {
      rawCounts.value = response;
      stats.value.forEach(stat => {
        if (stat.key === 'users_total') {
          stat.value = response.users?.total?.toString() || '0';
        } else {
          stat.value = response[stat.key]?.toString() || '0';
        }
      });
      chartSeries.value = [{ name: 'Count', data: stats.value.map(s => parseInt(s.value) || 0) }];
    }
  } catch (error) {
    console.error('Error fetching dashboard counts:', error);
  } finally {
    isLoading.value = false;
  }
};

const fetchTokenUsage = async () => {
  try {
    isTokensLoading.value = true;
    const params: any = {};
    if (tokenFilters.startDate) params.startDate = tokenFilters.startDate;
    if (tokenFilters.endDate) params.endDate = tokenFilters.endDate;
    if (tokenFilters.userType) params.userType = tokenFilters.userType;

    const response = await apiService.getTokenUsageTotals(params);
    if (response) {
      tokenUsageTotals.value = {
        total_tokens: response.overall_totals?.total_tokens || 0,
        input_tokens: response.overall_totals?.prompt_tokens || 0,
        output_tokens: response.overall_totals?.completion_tokens || 0,
        request_count: response.overall_totals?.request_count || 0
      };
      
      // Convert grouped_totals object to array for the table
      if (response.grouped_totals) {
        tokenUsageData.value = Object.entries(response.grouped_totals).map(([key, val]: [string, any]) => ({
          scope: val.label || key.charAt(0).toUpperCase() + key.slice(1),
          input_tokens: val.prompt_tokens || 0,
          output_tokens: val.completion_tokens || 0,
          total_tokens: val.total_tokens || 0,
          request_count: val.request_count || 0,
          details: `${val.request_count || 0} requests processed`
        }));
      } else {
        tokenUsageData.value = [];
      }
    }
  } catch (error) {
    console.error('Error fetching token usage:', error);
  } finally {
    isTokensLoading.value = false;
  }
};

// --- Chart Options ---
const chartOptions = computed(() => ({
  chart: {
    type: 'bar' as const,
    height: 400,
    toolbar: { show: false },
    zoom: { enabled: false },
    animations: { enabled: true, easing: 'easeinout', speed: 800 },
    fontFamily: 'Manrope, sans-serif'
  },
  plotOptions: {
    bar: { distributed: true, borderRadius: 8, horizontal: false, columnWidth: '60%' }
  },
  colors: stats.value.map(s => s.color),
  dataLabels: {
    enabled: true,
    style: { fontFamily: 'Manrope, sans-serif', fontSize: '11px', fontWeight: 700 },
    offsetY: -20,
    dropShadow: { enabled: false }
  },
  legend: { show: false },
  grid: { borderColor: 'rgba(124, 58, 237, 0.05)', strokeDashArray: 4 },
  xaxis: {
    categories: stats.value.map(s => s.label),
    labels: {
      rotate: -45,
      style: { fontFamily: 'Manrope, sans-serif', fontWeight: 600, fontSize: '10px', colors: '#6B7280' }
    },
    axisBorder: { show: false },
    axisTicks: { show: false }
  },
  yaxis: {
    labels: { style: { fontFamily: 'Manrope, sans-serif', colors: '#6B7280' } }
  },
  tooltip: {
    theme: 'light',
    custom: function({ series, seriesIndex, dataPointIndex, w }: any) {
      const label = w.globals.labels[dataPointIndex];
      const val = series[seriesIndex][dataPointIndex];
      const color = w.globals.colors[dataPointIndex];
      return `
        <div class="orchit-chart-tooltip" style="border-top: 3px solid ${color}">
          <div class="tooltip-label">${label}</div>
          <div class="tooltip-value">${val}</div>
        </div>
      `;
    }
  }
}));

const chartSeries = ref([{ name: 'Count', data: stats.value.map(s => parseInt(s.value) || 0) }]);

onMounted(() => {
  fetchDashboardData();
  applyDatePreset('this_month'); // Default to current month as per API behavior
});

return (_ctx: any,_cache: any) => {
  const _component_vue_feather = _resolveComponent("vue-feather")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("ul", _hoisted_5, [
            _createElementVNode("li", _hoisted_6, [
              _createElementVNode("button", {
                class: _normalizeClass(["nav-link rounded-pill px-4 py-2 d-flex align-items-center", { active: activeTab.value === 'main' }]),
                onClick: _cache[0] || (_cache[0] = ($event: any) => (activeTab.value = 'main')),
                type: "button"
              }, [
                _createVNode(_component_vue_feather, {
                  type: "activity",
                  size: "16",
                  class: "me-2"
                }),
                _cache[7] || (_cache[7] = _createTextVNode(" Main Overview ", -1))
              ], 2)
            ]),
            _createElementVNode("li", _hoisted_7, [
              _createElementVNode("button", {
                class: _normalizeClass(["nav-link rounded-pill px-4 py-2 d-flex align-items-center", { active: activeTab.value === 'tokens' }]),
                onClick: _cache[1] || (_cache[1] = ($event: any) => (activeTab.value = 'tokens')),
                type: "button"
              }, [
                _createVNode(_component_vue_feather, {
                  type: "database",
                  size: "16",
                  class: "me-2"
                }),
                _cache[8] || (_cache[8] = _createTextVNode(" API Token Usage ", -1))
              ], 2)
            ])
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_8, [
      (activeTab.value === 'main')
        ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
            _createElementVNode("div", _hoisted_10, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(stats.value, (stat, index) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: index,
                  class: "col-xl-2 col-lg-3 col-md-4 col-sm-6"
                }, [
                  _createVNode(_component_router_link, {
                    to: stat.route,
                    class: "stat-link"
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_11, [
                        _createElementVNode("div", {
                          class: "stat-icon-wrap",
                          style: _normalizeStyle({ backgroundColor: stat.color + '20', color: stat.color })
                        }, [
                          _createVNode(_component_vue_feather, {
                            type: stat.icon,
                            size: "20"
                          }, null, 8, ["type"])
                        ], 4),
                        _createElementVNode("div", _hoisted_12, [
                          _createElementVNode("h3", _hoisted_13, [
                            (isLoading.value)
                              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                  _createTextVNode("...")
                                ], 64))
                              : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                  _createTextVNode(_toDisplayString(stat.value), 1)
                                ], 64))
                          ]),
                          _createElementVNode("p", _hoisted_14, _toDisplayString(stat.label), 1)
                        ])
                      ])
                    ]),
                    _: 2
                  }, 1032, ["to"])
                ]))
              }), 128))
            ]),
            _createElementVNode("div", _hoisted_15, [
              _createElementVNode("div", _hoisted_16, [
                _createElementVNode("div", _hoisted_17, [
                  _createElementVNode("div", _hoisted_18, [
                    _cache[9] || (_cache[9] = _createElementVNode("div", null, [
                      _createElementVNode("h2", { class: "chart-section-title" }, "Ticker Analytics"),
                      _createElementVNode("p", { class: "chart-section-subtitle" }, "Comprehensive performance overview of all system metrics")
                    ], -1)),
                    _createElementVNode("div", _hoisted_19, [
                      _createVNode(_component_vue_feather, {
                        type: "bar-chart-2",
                        size: "20"
                      })
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_20, [
                    _createVNode(_unref(apexchart), {
                      type: "bar",
                      height: "400",
                      options: chartOptions.value,
                      series: chartSeries.value
                    }, null, 8, ["options", "series"])
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_21, [
              _createElementVNode("div", _hoisted_22, [
                _createElementVNode("div", _hoisted_23, [
                  _cache[12] || (_cache[12] = _createElementVNode("h3", {
                    class: "chart-section-title mb-3",
                    style: {"font-size":"1rem"}
                  }, "User Distribution", -1)),
                  _createElementVNode("div", _hoisted_24, [
                    _createElementVNode("div", _hoisted_25, [
                      _cache[10] || (_cache[10] = _createElementVNode("div", {
                        class: "breakdown-label",
                        style: {"color":"#10B981","font-size":"0.75rem","font-weight":"700","text-transform":"uppercase"}
                      }, "Paid Users", -1)),
                      _createElementVNode("div", _hoisted_26, [
                        (isLoading.value)
                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                              _createTextVNode("...")
                            ], 64))
                          : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                              _createTextVNode(_toDisplayString(rawCounts.value.users?.paid || 0), 1)
                            ], 64))
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_27, [
                      _cache[11] || (_cache[11] = _createElementVNode("div", {
                        class: "breakdown-label",
                        style: {"color":"#F59E0B","font-size":"0.75rem","font-weight":"700","text-transform":"uppercase"}
                      }, "Free Users", -1)),
                      _createElementVNode("div", _hoisted_28, [
                        (isLoading.value)
                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                              _createTextVNode("...")
                            ], 64))
                          : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                              _createTextVNode(_toDisplayString(rawCounts.value.users?.free || 0), 1)
                            ], 64))
                      ])
                    ])
                  ])
                ])
              ])
            ])
          ]))
        : _createCommentVNode("", true),
      (activeTab.value === 'tokens')
        ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
            _createElementVNode("div", _hoisted_30, [
              _createElementVNode("div", _hoisted_31, [
                _cache[13] || (_cache[13] = _createElementVNode("span", {
                  class: "text-muted small fw-bold me-2 align-self-center text-uppercase",
                  style: {"letter-spacing":"0.05em"}
                }, "Quick Presets:", -1)),
                (_openBlock(), _createElementBlock(_Fragment, null, _renderList(datePresets, (preset) => {
                  return _createElementVNode("button", {
                    key: preset.id,
                    class: _normalizeClass(["btn btn-sm rounded-pill px-3 py-1", activePreset.value === preset.id ? 'btn-primary shadow-sm' : 'btn-outline-secondary opacity-75']),
                    onClick: ($event: any) => (applyDatePreset(preset.id)),
                    style: {"font-size":"0.75rem","font-weight":"700"}
                  }, _toDisplayString(preset.label), 11, _hoisted_32)
                }), 64))
              ]),
              _createElementVNode("div", _hoisted_33, [
                _createElementVNode("div", _hoisted_34, [
                  _cache[14] || (_cache[14] = _createElementVNode("label", { class: "form-label small fw-bold" }, "Start Date", -1)),
                  _withDirectives(_createElementVNode("input", {
                    type: "date",
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((tokenFilters.startDate) = $event)),
                    class: "form-control orchit-input",
                    onChange: _cache[3] || (_cache[3] = ($event: any) => (activePreset.value = ''))
                  }, null, 544), [
                    [_vModelText, tokenFilters.startDate]
                  ])
                ]),
                _createElementVNode("div", _hoisted_35, [
                  _cache[15] || (_cache[15] = _createElementVNode("label", { class: "form-label small fw-bold" }, "End Date", -1)),
                  _withDirectives(_createElementVNode("input", {
                    type: "date",
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((tokenFilters.endDate) = $event)),
                    class: "form-control orchit-input",
                    onChange: _cache[5] || (_cache[5] = ($event: any) => (activePreset.value = ''))
                  }, null, 544), [
                    [_vModelText, tokenFilters.endDate]
                  ])
                ]),
                _createElementVNode("div", _hoisted_36, [
                  _cache[17] || (_cache[17] = _createElementVNode("label", { class: "form-label small fw-bold" }, "User Type", -1)),
                  _withDirectives(_createElementVNode("select", {
                    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((tokenFilters.userType) = $event)),
                    class: "form-select orchit-input"
                  }, [...(_cache[16] || (_cache[16] = [
                    _createElementVNode("option", { value: "" }, "All Users", -1),
                    _createElementVNode("option", { value: "internal" }, "Internal", -1),
                    _createElementVNode("option", { value: "external" }, "External", -1)
                  ]))], 512), [
                    [_vModelSelect, tokenFilters.userType]
                  ])
                ]),
                _createElementVNode("div", _hoisted_37, [
                  _createElementVNode("button", {
                    class: "btn btn-primary w-100 orchit-btn",
                    onClick: fetchTokenUsage,
                    disabled: isTokensLoading.value
                  }, [
                    (!isTokensLoading.value)
                      ? (_openBlock(), _createBlock(_component_vue_feather, {
                          key: 0,
                          type: "filter",
                          size: "16",
                          class: "me-2"
                        }))
                      : (_openBlock(), _createElementBlock("span", _hoisted_39)),
                    _cache[18] || (_cache[18] = _createTextVNode(" Apply Filters ", -1))
                  ], 8, _hoisted_38)
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_40, [
              _createElementVNode("div", _hoisted_41, [
                _createElementVNode("div", _hoisted_42, [
                  _createElementVNode("div", _hoisted_43, [
                    _createVNode(_component_vue_feather, {
                      type: "cpu",
                      size: "20"
                    })
                  ]),
                  _createElementVNode("div", _hoisted_44, [
                    _createElementVNode("h3", _hoisted_45, [
                      (isTokensLoading.value)
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                            _createTextVNode("...")
                          ], 64))
                        : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                            _createTextVNode(_toDisplayString(formatNumber(tokenUsageTotals.value.total_tokens || 0)), 1)
                          ], 64))
                    ]),
                    _cache[19] || (_cache[19] = _createElementVNode("p", { class: "stat-label" }, "Total Tokens", -1))
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_46, [
                _createElementVNode("div", _hoisted_47, [
                  _createElementVNode("div", _hoisted_48, [
                    _createVNode(_component_vue_feather, {
                      type: "arrow-down-left",
                      size: "20"
                    })
                  ]),
                  _createElementVNode("div", _hoisted_49, [
                    _createElementVNode("h3", _hoisted_50, [
                      (isTokensLoading.value)
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                            _createTextVNode("...")
                          ], 64))
                        : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                            _createTextVNode(_toDisplayString(formatNumber(tokenUsageTotals.value.input_tokens || 0)), 1)
                          ], 64))
                    ]),
                    _cache[20] || (_cache[20] = _createElementVNode("p", { class: "stat-label" }, "Input Tokens", -1))
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_51, [
                _createElementVNode("div", _hoisted_52, [
                  _createElementVNode("div", _hoisted_53, [
                    _createVNode(_component_vue_feather, {
                      type: "arrow-up-right",
                      size: "20"
                    })
                  ]),
                  _createElementVNode("div", _hoisted_54, [
                    _createElementVNode("h3", _hoisted_55, [
                      (isTokensLoading.value)
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                            _createTextVNode("...")
                          ], 64))
                        : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                            _createTextVNode(_toDisplayString(formatNumber(tokenUsageTotals.value.output_tokens || 0)), 1)
                          ], 64))
                    ]),
                    _cache[21] || (_cache[21] = _createElementVNode("p", { class: "stat-label" }, "Output Tokens", -1))
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_56, [
                _createElementVNode("div", _hoisted_57, [
                  _createElementVNode("div", _hoisted_58, [
                    _createVNode(_component_vue_feather, {
                      type: "zap",
                      size: "20"
                    })
                  ]),
                  _createElementVNode("div", _hoisted_59, [
                    _createElementVNode("h3", _hoisted_60, [
                      (isTokensLoading.value)
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                            _createTextVNode("...")
                          ], 64))
                        : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                            _createTextVNode(_toDisplayString(formatNumber(tokenUsageTotals.value.request_count || 0)), 1)
                          ], 64))
                    ]),
                    _cache[22] || (_cache[22] = _createElementVNode("p", { class: "stat-label" }, "Total Requests", -1))
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_61, [
              _createElementVNode("div", _hoisted_62, [
                _createElementVNode("table", _hoisted_63, [
                  _cache[26] || (_cache[26] = _createElementVNode("thead", null, [
                    _createElementVNode("tr", null, [
                      _createElementVNode("th", null, "Context / Scope"),
                      _createElementVNode("th", null, "Requests"),
                      _createElementVNode("th", null, "Input Tokens"),
                      _createElementVNode("th", null, "Output Tokens"),
                      _createElementVNode("th", null, "Total Tokens")
                    ])
                  ], -1)),
                  _createElementVNode("tbody", null, [
                    (isTokensLoading.value)
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, _renderList(5, (i) => {
                          return _createElementVNode("tr", { key: i }, [
                            (_openBlock(), _createElementBlock(_Fragment, null, _renderList(5, (j) => {
                              return _createElementVNode("td", { key: j }, [...(_cache[23] || (_cache[23] = [
                                _createElementVNode("div", { class: "placeholder-glow" }, [
                                  _createElementVNode("span", { class: "placeholder col-12" })
                                ], -1)
                              ]))])
                            }), 64))
                          ])
                        }), 64))
                      : (tokenUsageData.value.length > 0)
                        ? (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(tokenUsageData.value, (item, index) => {
                            return (_openBlock(), _createElementBlock("tr", { key: index }, [
                              _createElementVNode("td", null, [
                                _createElementVNode("div", _hoisted_64, [
                                  _createElementVNode("div", _hoisted_65, [
                                    _createVNode(_component_vue_feather, {
                                      type: "box",
                                      size: "14"
                                    })
                                  ]),
                                  _createElementVNode("div", null, [
                                    _createElementVNode("div", _hoisted_66, _toDisplayString(item.scope || 'General'), 1),
                                    _createElementVNode("div", _hoisted_67, _toDisplayString(item.details || 'System AI processing'), 1)
                                  ])
                                ])
                              ]),
                              _createElementVNode("td", null, [
                                _createElementVNode("span", _hoisted_68, _toDisplayString(formatNumber(item.request_count)), 1)
                              ]),
                              _createElementVNode("td", null, _toDisplayString(formatNumber(item.input_tokens)), 1),
                              _createElementVNode("td", null, _toDisplayString(formatNumber(item.output_tokens)), 1),
                              _createElementVNode("td", null, [
                                _createElementVNode("span", _hoisted_69, _toDisplayString(formatNumber(item.total_tokens)), 1)
                              ])
                            ]))
                          }), 128))
                        : (_openBlock(), _createElementBlock("tr", _hoisted_70, [
                            _createElementVNode("td", _hoisted_71, [
                              _createElementVNode("div", _hoisted_72, [
                                _createVNode(_component_vue_feather, {
                                  type: "info",
                                  size: "48"
                                })
                              ]),
                              _cache[24] || (_cache[24] = _createElementVNode("h5", { class: "text-muted mb-0" }, "No token usage data found", -1)),
                              _cache[25] || (_cache[25] = _createElementVNode("p", { class: "text-muted small" }, "Try adjusting your filters to see more results.", -1))
                            ])
                          ]))
                  ])
                ])
              ])
            ])
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}
}

})